// Stylesheets
import './assets/scss/site.scss';
import { hover } from './assets/modules/hover';
import { lazyload } from './assets/modules/lazyload';
import { fluidvideo } from './assets/modules/fluidvideo';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';
import { carousel } from './assets/modules/carousel';
import { slideList } from './assets/modules/slideList';
import { trigger } from './assets/modules/trigger';
import { contentfilter } from './assets/modules/contentfilter';

const init = () => {
  hover();
  lazyload();
  trigger();
  fluidvideo();
  initPhotoSwipeFromDOM('.js-pswp-container');
  carousel();
  slideList();
  contentfilter();
}

init();